module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00003-a7086253dddead2cb059539019d65c18.jpg";